import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';
import Layout from './components/Layout.jsx';
import Login from './pages/Login.jsx';
import Register from './pages/Register.jsx';
import StudentHome from './pages/StudentHome.jsx';
import TimerPage from './pages/TimerPage.jsx';
import MyData from './pages/MyData.jsx';
import CoachHome from './pages/CoachHome.jsx';
import CoachStudent from './pages/CoachStudent.jsx';
import Settings from './pages/Settings.jsx';

function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-ink-950">
      <div className="text-accent animate-pulse text-sm">加载中…</div>
    </div>
  );
}

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
}

function RequireStudent({ children }) {
  const { user } = useAuth();
  if (user && user.role !== 'student') return <Navigate to="/coach" replace />;
  return children;
}

function RequireCoach({ children }) {
  const { user } = useAuth();
  if (user && user.role !== 'coach') return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<RequireStudent><StudentHome /></RequireStudent>} />
        <Route path="/timer" element={<RequireStudent><TimerPage /></RequireStudent>} />
        <Route path="/data" element={<RequireStudent><MyData /></RequireStudent>} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/coach" element={<RequireCoach><CoachHome /></RequireCoach>} />
        <Route path="/coach/students/:id" element={<RequireCoach><CoachStudent /></RequireCoach>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
